export { CheckoutService } from './checkout';

export type {
  ShippingMethod,
  OrderExpanded,
  OrderLineItem,
  OrderLineItemVariant,
  ShippingAddress,
  OrderCancellationResponse
} from './interfaces';
